import { useMemo } from 'react';

/**
 * Derives the current workflow stage from case state.
 *
 * Stages (3-stage workflow):
 *   'upload'    – No structured info and no extraction in progress
 *   'results'   – Structured info exists OR extraction is in progress
 *   'documents' – HPI or diagnosis has been generated
 *
 * @param {Object} params
 * @param {Object|null} params.structuredInfo
 * @param {Object|null} params.extractionProgress  – { completed, total }
 * @param {string}      params.hpiText
 * @param {string}      params.diagnosis
 * @param {Object|null} params.generatedDocuments   – map of doc name → { content }
 * @returns {{ stage: string }}
 */
export default function useWorkflowStage({ structuredInfo, extractionProgress, hpiText, diagnosis, generatedDocuments }) {
    const stage = useMemo(() => {
        // Stage 3: HPI, diagnosis, or generatedDocuments exists
        if (hpiText || diagnosis || generatedDocuments) {
            return 'documents';
        }

        // Stage 2: Extraction in progress or structured info populated
        if (structuredInfo || extractionProgress) {
            return 'results';
        }

        // Stage 1: Nothing yet
        return 'upload';
    }, [structuredInfo, extractionProgress, hpiText, diagnosis, generatedDocuments]);

    return { stage };
}
